import { useAppDisplayModeContext } from '@archipro-design/aria';
import { useSaveToDesignBoard } from '~/modules/design-board';
import LatestArticlesDesktop from '../latest-articles/LatestArticles.desktop';
import type { TileProps } from '../../type';
import FilmsSectionMobile from './FilmsSection.mobile';

interface LatestArticlesProps {
    latestArticles: TileProps[];
    loadMoreLink?: string;
}

const FilmsSection = ({
    latestArticles,
    loadMoreLink,
}: LatestArticlesProps) => {
    const { mobile: isMobile } = useAppDisplayModeContext();
    const { favouriteItem } = useSaveToDesignBoard('ArticlePin');

    const title = isMobile ? 'Films ' : 'Latest Films';

    return (
        <>
            {isMobile ? (
                <FilmsSectionMobile
                    {...{ title, latestArticles, favouriteItem }}
                />
            ) : (
                <LatestArticlesDesktop
                    {...{
                        title,
                        latestArticles,
                        loadMoreLink,
                        useFilmsLayout: true,
                        favouriteItem,
                    }}
                />
            )}
        </>
    );
};

export default FilmsSection;
